<template>
  <section>
    <h2>Slider</h2>
    <m-row wrap class="row">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="Tab 1" key="1">Content of Tab Pane 1</a-tab-pane>
        <a-tab-pane tab="Looooooooooooooooooong word" key="2">Content of Tab Pane 2</a-tab-pane>
        <a-tab-pane tab="Tab 3" key="3">Content of Tab Pane 3</a-tab-pane>
      </a-tabs>
    </m-row>
  </section>
</template>
<script>
export default {
  name: 'Slider',
};
</script>
